import { render, staticRenderFns } from "./container.vue?vue&type=template&id=21440345"
import script from "./container.vue?vue&type=script&lang=ts"
export * from "./container.vue?vue&type=script&lang=ts"
import style0 from "./container.vue?vue&type=style&index=0&id=21440345&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\WebDev\\Source\\PeppermillReno.com\\[DEV]\\[WEB] PeppermillReno.com DEV\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21440345')) {
      api.createRecord('21440345', component.options)
    } else {
      api.reload('21440345', component.options)
    }
    module.hot.accept("./container.vue?vue&type=template&id=21440345", function () {
      api.rerender('21440345', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "library/js/components/view-room-details/container.vue"
export default component.exports